(function ($) {
	$(document).ready(function () {
		if (document.getElementById("map")) {
			function initMap() {
				const m = $('#map');
				// Winterthur - Center of the Universe - Default Value
				const lat = m.data('lat') ? parseFloat(String(m.data('lat')).replaceAll(',', '.')) : 47.4988196;
				const lng = m.data('lng') ? parseFloat(String(m.data('lng')).replaceAll(',', '.')) : 8.7236889;
				const templateUrl = m.data('templateurl');
				const markerIcon = {
					url: templateUrl + '/assets/img/map-marker.svg',
					scaledSize: new google.maps.Size(50, 50)
				};
				const location = { lat: lat, lng: lng };
				const map = new google.maps.Map(document.getElementById("map"), {
					mapId: "f1b73a765ed60e76",
					center: location,
					zoom: 16,
				});
				const marker = new google.maps.Marker({
					position: location,
					map,
					title: "Theater am Gleis",
					icon: markerIcon
				});
			}
			window.initMap = initMap;
			initMap();
		}
	});
})(jQuery);

